/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForFreshservice extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForFreshservice");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForFreshservice.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForFreshservice>): ServiceAccountCredentialsForFreshservice {
        let obj = Object.assign(new ServiceAccountCredentialsForFreshservice(), model);
        ServiceAccountCredentialsForFreshservice.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForFreshservice>): ServiceAccountCredentialsForFreshservice {
        if (!model) return null;
        return ServiceAccountCredentialsForFreshservice.newInstance(<ServiceAccountCredentialsForFreshservice> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForFreshservice) {
        if (!obj) return;

        models.ServiceAccountCredentialsForFreshservice.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForFreshservice): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForFreshservice.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of the domain. This is a required field.
     */
    domain: string;

    /**
     * API Key. This is a required field.
     */
    api_key: string;

}
